module.exports = __webpack_public_path__ + "img/MapThumb_WateringHole.d85aa4e9.webp";